import {
  CreditCard,
  ShoppingBag,
  XCircle,
  Truck,
  MapPin,
  CheckCircle,
  ShoppingCart,
  UserPlus,
  RotateCcw,
  Sparkles,
  type LucideIcon,
} from 'lucide-react';

/**
 * Maps the `icon` string from the backend playbook catalog to a concrete
 * lucide-react icon component. Kept as a pure lookup so it's trivially testable
 * and so adding a new playbook on the backend doesn't crash the UI — unknown
 * icons fall through to the Sparkles placeholder.
 */
export const PLAYBOOK_ICON_MAP: Record<string, LucideIcon> = {
  'credit-card': CreditCard,
  'shopping-bag': ShoppingBag,
  'x-circle': XCircle,
  'truck': Truck,
  'map-pin': MapPin,
  'check-circle': CheckCircle,
  'shopping-cart': ShoppingCart,
  'user-plus': UserPlus,
  'rotate-ccw': RotateCcw,
};

export function resolvePlaybookIcon(icon: string | undefined | null): LucideIcon {
  if (!icon) return Sparkles;
  return PLAYBOOK_ICON_MAP[icon] ?? Sparkles;
}
